import normalize from "json-api-normalizer";

import BaseService from "./BaseService";

export default {
  search(query) {
    return BaseService.get(`patients/search?query=${query}`).then(response => {
      const data = normalize(response.data);
      let patients = {};
      if (data) {
        patients = data.patients;
      }
      return patients;
    });
  },

  update(data) {
    return BaseService.patch("patients", `patients/${data.id}`, data)
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  }
};
